
import Field from "@/components/crud/fields/FieldMixin.vue";
import Vue from "vue";

export default Vue.extend({
  name: "KTextarea",
  mixins: [Field],
  computed: {},
});
